import { CatAccordionPanel } from '@blocks-react/components/AccordionPanel';
import { SystemAndComponentAccordionPanelProps } from '../types';

export const SystemAndComponentAccordionPanel = ({
  children,
  classname,
  handleClick,
  datatrackevent,
  datatrackattrnltext,
  datatrackattrcontext
}: SystemAndComponentAccordionPanelProps) => {
  return (
    <CatAccordionPanel
      className={classname}
      onClick={handleClick}
      data-track-event={datatrackevent}
      data-track-attr-nltext={datatrackattrnltext}
      data-track-attr-context={datatrackattrcontext}
      alignToggleRight
    >
      {children}
    </CatAccordionPanel>
  );
};
